// @flow

import type { EventSourceMap, PropsSchema } from '../../type'

import * as React from 'react'
import { appendPropsSchema, appendPropsActions } from '../util/schemaUtil'

export default function (WrappedComponent: React.ComponentType<*>) {
  class OnClick extends React.PureComponent<{
    events: EventSourceMap,
    callActions: (actionName: string, dynamicData: any) => {}
  }> {
    static schema: PropsSchema = appendPropsSchema(WrappedComponent, [
      {
        type: 'event',
        event: 'onClick',
        title: '点击事件'
      }
    ]);

    static actions = appendPropsActions(WrappedComponent);

    wrappedComponent: ?React.Component<*>;

    onClick = () => {
      this.props.callActions('onClick')
    };

    render (): React.Node {
      return (
        <WrappedComponent
          ref={ref => {
            if (ref) {
              this.wrappedComponent = ref
            }
          }}
          {...this.props}
          onClick={this.onClick}
        />
      )
    }
  }

  return OnClick
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/hoc/onClickEvent.js